import { defineAsyncComponent } from 'vue';
import { app, mountApp } from '@/js/app-entries/app-entry-points/global';

if (document.querySelector('converter')) {
    const Converter = defineAsyncComponent(() => import('@/js/cryptocurrencies/converter/Converter.vue'));
    app.component('Converter', Converter);
}

mountApp();
